import { CardList } from "@shared-kernel/primary/shared/card-list/card-list.content";
import { ActivityCard } from "@shared-kernel/primary/shared/card-list/activity-card.content";
import type { UnpaidLessonVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { formatToCurrency, formatDateToLocale } from "@utils/formatting";
import { formatUnpaidLesson } from "@academy-context/read/application/use-cases/student/summary-retrieval/utils/activity-card-formatters";

interface Props {
  lessons: UnpaidLessonVM[];
}

export const UnpaidLessonsCardList = ({ lessons }: Props) => {
  return (
    <CardList
      items={lessons}
      getGroupingKeyAndLabel={l => `Enregistré le ${formatDateToLocale(l.creationDate)}`}
      getSortDate={l => l.creationDate}
      getKey={l => l.id}
      renderItem={lesson => (
        <ActivityCard
          entry={formatUnpaidLesson(lesson)}
          trailing={<span className="text-lg font-bold">{formatToCurrency(lesson.amount)}</span>}
        />
      )}
    />
  );
};
